import { useMutation, useQueryClient } from '@tanstack/react-query'
import { z } from 'zod'

import { API_ENDPOINTS } from '../../../common/apiEndpoints'
import { contractDayReservableAreasKey } from './useAPIGetContractDayReservableAreas'

import { post } from 'api/apiClient'

type TerminateReservationPayload = {
  rentableHierarchyId: number
  endDate: string
}

const terminateReservation = (
  contractUuid: string,
  payload: TerminateReservationPayload
) =>
  post<void>(
    API_ENDPOINTS.CONTRACT_DAY_RESERVABLE_AREA_RESERVATIONS_TERMINATE.replace(
      ':contractUuid',
      contractUuid
    ),
    payload,
    z.void()
  )

export const useAPITerminateContractDayReservableAreaReservation = (
  contractUuid: string | undefined
) => {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: (payload: TerminateReservationPayload) => {
      if (!contractUuid) throw new Error('Contract UUID is required')
      return terminateReservation(contractUuid, payload)
    },
    onSuccess: () => {
      if (contractUuid) {
        queryClient.invalidateQueries({
          queryKey: contractDayReservableAreasKey(contractUuid, 'all'),
        })
        queryClient.invalidateQueries({
          queryKey: contractDayReservableAreasKey(contractUuid, 'own'),
        })
      }
    },
  })
}
